import React, { useState } from 'react';
import './CSS/googlemaps.css';
import exclamination from '../Icons/exclamination.png';
import { Link } from "react-router-dom";
import { FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';

const GoogleMapWithContactForm = ({ onContactClick }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    number: "",
    subject: "",
    message: ""
  });

     const [menuOpen, setMenuOpen] = useState(false);
      
        const toggleMenu = () => {
          setMenuOpen(!menuOpen);
        };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, number, subject, message } = formData;

    const bodyContent = `Name: ${name}%0D%0AEmail: ${email}%0D%0AMobile: ${number}%0D%0A%0D%0A${message}`;

    if (isMobileDevice()) {
      // For Mobile: Use mailto to open Gmail App
      const mailtoLink = `mailto:designvioux@gmail.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\nMobile: ${number}\n\n${message}`)}`;
      window.location.href = mailtoLink;
    } else {
      // For Desktop: Open Gmail Compose in browser
      const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=designvioux@gmail.com&su=${encodeURIComponent(subject)}&body=${bodyContent}`;
      window.open(gmailLink, '_blank');
    }

    // Reset form after submission
    setFormData({
      name: "",
      email: "",
      number: "",
      subject: "",
      message: ""
    });
  };

  return (
    <div className='Map-cont'>
       <header className="home-header">
        <div className="logo">
          <img
            alt="Designvio.pvt.Ltd"
            className="logo-icon"
            src="../Images/DLogo.png"
          />
        </div>

        <div className="hamburger" onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <a href="#about">ABOUT</a>
          <a href="#services">SERVICES</a>
          <a href="#work">WORK</a>
          <a href="#contact" onClick={onContactClick}>
            CONTACT
          </a>
        </nav>
      </header>
     <div className="contact-header">
  <div className='faq-top-text'>
    <img src={exclamination} className='ex-icon4' alt="Contact icon" />
    <span>Contact Us</span>
  </div>
  <button 
    className="close-page-btn" 
    onClick={() => window.history.back()}
    aria-label="Close and go back"
  >
    ×
  </button>
</div>

      <h2 className='google-heading'>Our Office Location</h2>
      
      <div className="combined-container">
      <div className="form-section">
          <form onSubmit={handleSubmit} className="Contact-Cont">
            <h2 className="contact-heading">Send Us a Message</h2>

            <label>Enter Your Name</label>
            <input 
              name="name" 
              value={formData.name} 
              onChange={handleChange} 
              required 
            />

            <label>Enter Your Email</label>
            <input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              pattern="^[a-zA-Z0-9._%+-]+@gmail\.com$"
              title="Please enter a valid Gmail address (e.g., example@gmail.com)"
              required
            />

            <label>Enter Your Mobile Number</label>
            <input
              name="number"
              type="tel"
              value={formData.number}
              onChange={handleChange}
              pattern="^\d{10}$"
              title="Please enter a 10-digit mobile number"
              required
            />

            <label>Enter Subject</label>
            <input 
              name="subject" 
              value={formData.subject} 
              onChange={handleChange} 
              required 
            />

            <label>Enter Your Message</label>
            <textarea 
              name="message" 
              value={formData.message} 
              onChange={handleChange} 
              required 
            />

            <button type="submit">Send Message</button>
          </form>
        </div>

         <div className="map-section">
          <div className='google-map-iframe-cont'>
            <iframe
              className="google-map-iframe"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800.993195316485!2d73.99692947494228!3d17.697781583243245!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc23963d1c22b9b%3A0x4131cc6b49f60b37!2sDesignvio%20Pvt%20Ltd%20-%20UI%20UX%20Training!5e0!3m2!1sen!2sin!4v1747139342353!5m2!1sen!2sin"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Map Embed"
            ></iframe>
          </div>
        </div>
         <footer className="footer" id='contact'>
              <div className="footer-top">
                <div className="footer-left">
                  <img src="../Images/DLogo.png" alt="Designvio Logo" className="footer-logo" />
         <div className="footer-address">
            <h3>Address</h3>
            <p>Branch 1: Designvio 523/B Karanje Peth, Satara.</p>
            <p>Branch 2: Designvio AssemblyRd, New Shahupuri, Kolhapur.</p>
          </div>
                  <nav className="footer-page">
                             {/* <a className='link-c' href="#about">ABOUT-US</a> */}
                           <Link className='link-c' to="/privacy-policy">Privacy Policy</Link>
                           <Link className='link-c' to="/terms-conditons">Terms And Conditions</Link>
                           <Link className='link-c' to="/cancellation">Cancellation And Refunf Policy</Link>
                           <Link className='link-c' to="/shipping">Shipping And Delivery Policy</Link>
                           </nav>
        
                 
                </div>
        
                <div className="footer-right">
                  <div className="footer-box">
                    <h3 className='touch'>GET IN TOUCH</h3>
                    <p className='tel-link'>Tel: <a className='tel-link' href="tel:‪+917058035999‬">‪+91 7058035999‬</a> / <a className='tel-link' href="tel:‪+917875010115‬">‪+91 7875010115‬</a></p>
                    <hr />
                    <h3 className='follow'>FOLLOW US</h3>
                    <div className="social-icons">
                      <a className='social-link' href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                      <a className='social-link' href="https://twitter.com" target="_blank" rel="noreferrer"><FaTwitter /></a>
                      <a className='social-link' href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedin /></a>
                    </div>
                  </div>
                </div>
        
              </div>
        
              
              <div className="footer-bottom">
                <p>© 2024 Copyright <strong className='cp'>Designvio</strong></p>
               
              </div>
       
            </footer>
      </div>
    </div>
  );
};

export default GoogleMapWithContactForm;